import axiosInstance from "./AxiosInstance";

export function getNotification(data) {
  return axiosInstance.post("/notification/get-notifications", data);
}

export function allRead(data) {
  return axiosInstance.post("/notification/update-all-read-by", data);
}
